var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 6.25017C1.66675 5.09958 2.59949 4.16684 3.75008 4.16684H10.0001C11.1507 4.16684 12.0834 5.09958 12.0834 6.25017V14.5835C12.0834 15.7341 11.1507 16.6668 10.0001 16.6668H3.75008C2.59949 16.6668 1.66675 15.7341 1.66675 14.5835V6.25017Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7426 7.40181C14.3897 7.57826 14.1667 7.93895 14.1667 8.33351V12.5002C14.1667 12.8947 14.3897 13.2554 14.7426 13.4319L16.8259 14.4735C17.1488 14.635 17.5323 14.6177 17.8394 14.4279C18.1465 14.2381 18.3334 13.9029 18.3334 13.5418V7.29184C18.3334 6.93082 18.1465 6.59554 17.8394 6.40575C17.5323 6.21595 17.1488 6.19869 16.8259 6.36015L14.7426 7.40181Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUpload);
export default __webpack_public_path__ + "static/media/video-upload.1018b0998f066b64885edf08e363213d.svg";
export { ForwardRef as ReactComponent };